import classNames from 'classnames';
import { uniq } from 'lodash';
import type { ComponentPropsWithoutRef, ReactNode } from 'react';

import { Label } from '../label/Label';
import styles from './FormField.module.css';
import { SupportingText } from './SupportingText';

interface FormFieldProps extends ComponentPropsWithoutRef<'div'> {
  label: string;
  htmlFor?: string;
  supportingText?: ReactNode | string;
  errors?: string[];
}

export const FormField = ({
  label,
  htmlFor,
  supportingText,
  errors,
  className,
  children,
  ...rest
}: FormFieldProps) => {
  return (
    <div className={classNames(styles.formField, className)} {...rest}>
      <Label
        as={htmlFor !== undefined ? 'label' : 'span'}
        {...(htmlFor !== undefined && { htmlFor })}
        size="sm"
      >
        {label}
      </Label>
      {children}
      {typeof supportingText === 'string' ? (
        <SupportingText>{supportingText}</SupportingText>
      ) : (
        supportingText
      )}
      {uniq(errors)?.map((error) => (
        <SupportingText key={error} isInvalid>
          {error}
        </SupportingText>
      ))}
    </div>
  );
};
